import { requst } from '../config'

// 日历上数据
export const getActivityDiaryCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/activity/diary/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getActivityDiaryDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getActivityDiaryByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/activity/diary/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getActivityDiaryByIdApi = id => {
    const url = `/monitor/activity/diary/${id}`
    return requst.get(url)
}

// 获取 Activities 数据
export const getActivitiesDataApi = id => {
    const url = `/monitor/activity/item/list?activityId=${id}`
    return requst.get(url)
}

// 获取 Operation 数据
export const getOperationDataApi = id => {
    const url = `/monitor/activity/operation/list?activityId=${id}`
    return requst.get(url)
}

// 提交 ActivityDiary 总结
export const postActivityDiaryCommentApi = commentData => {
    const url = `/monitor/activity/diary`
    return requst.post(url, { ...commentData })
}

// 修改 ActivityDiary 总结
export const putActivityDiaryCommentApi = (commentData, id) => {
    const url = `/monitor/activity/diary`
    return requst.put(url, { ...commentData, id })
}

// 提交 Activities 数据
export const postActivitiesDataApi = (activitiesData, id) => {
    const url = `/monitor/activity/item/addOrUpdateBatch/${id}`
    return requst.post(url, activitiesData)
}

// 提交 Operation 数据
export const postOperationDataApi = (operationParams, id) => {
    const url = `/monitor/activity/operation/addOrUpdateBatch/${id}`
    return requst.post(url, operationParams)
}
